import React, { Component } from "react";
import { connect } from "react-redux";
import PageLayout from "./navigation/PageLayout/PageLayout";

import * as actions from "../store/actions/index";

import { Result, Button, message } from "antd";

import setAuthToken from "../utils/setAuthToken";

import Loading from "../components/Loading";

import moment from "moment-timezone";
moment.tz.setDefault("Etc/UTC");

class Main extends Component {
  state = {
    data: null,
  };

  async componentDidMount() {
    this.props.setUser(this.props.user);
    const token = await this.props.token;
    message.config({ maxCount: 1 });
    setAuthToken(token);

    await this.props.setSmData();
  }

  logout = () => {
    this.props.logout();
  };

  render() {
    let mainPage = null;

    if (this.props.permission) {
      if (this.props.permission.sm_solution_access || this.props.permission.sm_end_user_access) {
        mainPage = (
          <PageLayout
            user={this.props.user}
            loading={this.props.loading}
            logout={this.logout}
          />
        );
      } else {
        mainPage = (
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
            extra={
              <Button onClick={this.logout} type="primary">
                Logout
              </Button>
            }
          />
        );
      }
    } else {
      if (!this.props.smError) {
        mainPage = <Loading />;
      } else {
        mainPage = (
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
            extra={
              <Button onClick={this.logout} type="primary">
                Logout
              </Button>
            }
          />
        );
      }
    }
    return mainPage;
  }
}

const mapStateToProps = (state) => {
  return {
    permission: state.api.permission,
    smError: state.api.error,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setUser: (authUser) => dispatch(actions.setUser(authUser)),
  setToken: (token) => dispatch(actions.setToken(token)),
  setSmData: (email) => dispatch(actions.setSmData(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
